(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .factory('PublicProfileSearch', PublicProfileSearch);

    PublicProfileSearch.$inject = ['$resource'];

    function PublicProfileSearch($resource) {
        var resourceUrl =  'api/_search/public-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
